export default [
  {
    path: 'managestaff-new',
    name: 'laborManagement.opsprofile',
    meta: {
      title: 'Ops Profile',
    },
    redirect: '/wms-labormanagement/staffmanagement/managestaff',
  },
];
